module.exports = __webpack_public_path__ + "static/shebao-82af9a1e2b82f05036b6bdb7e9f7651d.png";